module.exports = __webpack_public_path__ + "static/media/logo.56419127.svg";